export default {
    "notification": {
        "title": "Notifications",
        "showNotifications": "Afficher les notifications",
        "hideNotifications": "Masquer les notifications",
        "clearNotifications": "Effacer les notifications",
    }
};
